import { useState } from "react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { fmtCurrency } from "@/lib/format";
import { STATUS } from "@/design/tokens";
import { OpportunityCard } from "@/components/sales/OpportunityCard";
import { LostReasonDialog } from "@/components/sales/LostReasonDialog";
import { isQualifyError, qualifyThen } from "@/components/crm/QualifyHost";

export const changeStage = async (oppId, stageId, lostReason) => {
  try { await api.post(`/sales/opportunities/${oppId}/stage`, { stage_id: stageId, lost_reason: lostReason }); toast.success("Fase aggiornata"); return true; }
  catch (e) {
    if (isQualifyError(e)) return (await qualifyThen(e, oppId)) ? changeStage(oppId, stageId, lostReason) : false;
    toast.error(errorMessage(e)); return false;
  }
};

const Column = ({ col, canMove, onDrop, dragging, setDragging }) => {
  const [over, setOver] = useState(false);
  const s = col.stage;
  return (
    <div className={`flex w-72 shrink-0 flex-col rounded-card border bg-slate-50/70 ${over ? "border-brand-200 bg-brand-50/40" : "border-line"}`}
      onDragOver={(e) => { if (canMove && dragging) { e.preventDefault(); setOver(true); } }} onDragLeave={() => setOver(false)}
      onDrop={(e) => { e.preventDefault(); setOver(false); onDrop(s); }} data-testid={`board-column-${s.key}`}>
      <div className="border-b border-line px-3 py-2.5">
        <div className="flex items-center gap-2">
          <span className={`h-2 w-2 rounded-full ${STATUS[s.tone]?.dot || "bg-slate-400"}`} />
          <p className="text-sm font-semibold text-ink">{s.name}</p>
          <span className="text-xs text-slate-400">{s.probability}%</span>
          <span className="ml-auto rounded-full bg-white px-2 text-xs font-semibold text-slate-600" data-testid={`board-column-count-${s.key}`}>{col.count}</span>
        </div>
        <p className="mt-0.5 text-xs text-slate-500">{fmtCurrency(col.value)} · pesato {fmtCurrency(col.weighted)}</p>
      </div>
      <div className="flex min-h-24 flex-col gap-2 p-2">
        {col.items.map((o) => <OpportunityCard key={o.id} o={o} draggable={canMove}
          onDragStart={(e) => { e.dataTransfer.setData("text/plain", o.id); setDragging(o); }} />)}
        {col.count > col.items.length && <p className="px-1 text-xs text-slate-400">+ altre {col.count - col.items.length} (vedi Lista)</p>}
      </div>
    </div>
  );
};

export const PipelineBoard = ({ columns, canMove, onChanged }) => {
  const [dragging, setDragging] = useState(null);
  const [lost, setLost] = useState(null);
  const drop = async (stage) => {
    const o = dragging;
    setDragging(null);
    if (!o || o.pipeline_stage_id === stage.id) return;
    if (stage.outcome === "lost") { setLost({ o, stage }); return; }
    if (await changeStage(o.id, stage.id)) onChanged();
  };
  return (
    <>
      <div className="-mx-4 overflow-x-auto px-4 pb-3 sm:mx-0 sm:px-0" data-testid="pipeline-board">
        <div className="flex gap-3">{columns.map((c) => <Column key={c.stage.id} col={c} canMove={canMove} onDrop={drop} dragging={dragging} setDragging={setDragging} />)}</div>
      </div>
      <LostReasonDialog open={!!lost} onCancel={() => setLost(null)}
        onConfirm={async (reason) => { const ok = await changeStage(lost.o.id, lost.stage.id, reason); setLost(null); if (ok) onChanged(); }} />
    </>
  );
};
